import { canAccessFeature } from '@/js/core/utils/feature-access';
import { FEATURES } from '@/js/core/constants/features';

/**
 * Whether the current user may open the Academic Calendar (full academic year).
 *
 * Sourced from the hydrated feature list rather than the profile's audience
 * role: guests resolve to the 'affiliate' role, so a role check here would
 * grant them access the server denies. The server decides this in
 * FullAcademicYearAccess and hydrates the result, keeping both sides in step.
 */
export function canAccessFullAcademicYear() {
  return canAccessFeature(window.gsdNowAppData?.userData, FEATURES.fullAcademicYear);
}
